import { render, staticRenderFns } from "./distribuzione.vue?vue&type=template&id=0289fb44&"
import script from "./distribuzione.vue?vue&type=script&lang=js&"
export * from "./distribuzione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports